import { render, staticRenderFns } from "./DisplayModeVueEditor.vue?vue&type=template&id=0b82fc70&scoped=true&"
import script from "./DisplayModeVueEditor.vue?vue&type=script&lang=js&"
export * from "./DisplayModeVueEditor.vue?vue&type=script&lang=js&"
import style0 from "./DisplayModeVueEditor.vue?vue&type=style&index=0&id=0b82fc70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82fc70",
  null
  
)

export default component.exports